import {
  TABLE_ROW_HEADER_DOUBLE_LINE,
  TABLE_ROW_HEADER_DOUBLE_LINE_NO_LOGO,
  TABLE_ROW_HEADER_LINE,
  TABLE_ROW_HEADER_QUADRUPLE_LINE_NO_LOGO,
  TABLE_ROW_HEADER_QUINTUPLE_LINE_NO_LOGO,
  TABLE_ROW_HEADER_SEXTUPLE_LINE_NO_LOGO,
  TABLE_ROW_HEADER_TRIPLE_LINE_NO_LOGO,
  TABLE_ROW_MULTIPLE_LINE,
  TABLE_ROW_QUADRUPLE_LINE,
  TABLE_ROW_SINGLE_LINE,
  TABLE_ROW_TRIPLE_LINE,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";
import { View } from "@react-pdf/renderer";

export type PDFTableRowType =
  | "SingleLine"
  | "DoubleLine"
  | "TripleLine"
  | "Quadruple"
  | "HeaderLine"
  | "HeaderSingleLine"
  | "HeaderDoubleLine"
  | "HeaderDoubleLineNoLogo"
  | "HeaderTripleLineNoLogo"
  | "HeaderQuadrupleLineNoLogo"
  | "HeaderQuintupleLineNoLogo"
  | "HeaderSextupleLineNoLogo"
  | "CommentLine"
  | "FeatureIncludeLine";

export interface PDFTableRowProps {
  children: React.ReactNode;
  type?: PDFTableRowType;
  color?: "white" | "gray" | "dark" | "primary";
  rowKey?: string | number;
  forceShowBorderBottom?: boolean;
}

export const PDFTableRow = ({
  children,
  type,
  color = "white",
  rowKey,
  forceShowBorderBottom = false,
}: PDFTableRowProps) => {
  const rowHeightMapping = {
    SingleLine: TABLE_ROW_SINGLE_LINE,
    DoubleLine: TABLE_ROW_MULTIPLE_LINE,
    TripleLine: TABLE_ROW_TRIPLE_LINE,
    Quadruple: TABLE_ROW_QUADRUPLE_LINE,
    HeaderLine: TABLE_ROW_HEADER_LINE,
    HeaderDoubleLine: TABLE_ROW_HEADER_DOUBLE_LINE,
    HeaderDoubleLineNoLogo: TABLE_ROW_HEADER_DOUBLE_LINE_NO_LOGO,
    HeaderTripleLineNoLogo: TABLE_ROW_HEADER_TRIPLE_LINE_NO_LOGO,
    HeaderQuadrupleLineNoLogo: TABLE_ROW_HEADER_QUADRUPLE_LINE_NO_LOGO,
    HeaderQuintupleLineNoLogo: TABLE_ROW_HEADER_QUINTUPLE_LINE_NO_LOGO,
    HeaderSextupleLineNoLogo: TABLE_ROW_HEADER_SEXTUPLE_LINE_NO_LOGO,
    HeaderSingleLine: 25,
    CommentLine: 260,
    FeatureIncludeLine: 120,
  };

  const colorMapping = {
    white: "#FFFFFF",
    gray: "#e0e2e5",
    dark: "#b1b6bf",
    primary: "#515B6F",
  };

  return (
    <View
      key={rowKey}
      style={{
        flexDirection: "row",
        height: type ? rowHeightMapping[type] : "auto",
        minHeight: type ? rowHeightMapping[type] : "auto",
        borderColor: "#7C8493",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth:
          type === "HeaderLine" ||
          type === "HeaderSingleLine" ||
          forceShowBorderBottom
            ? 1
            : 0,
        backgroundColor: color ? colorMapping[color] : "transparent",
      }}
    >
      {children}
    </View>
  );
};
